<template>
  <div>
    <!-- 头部 -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.line_name_cn" placeholder="请输入线路名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.map_name_cn" placeholder="请输入地图名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" icon="el-icon-plus" @click="addLine"
          v-if="check_auth('/web/area/area_bind_line')">
          增加线路</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table class="elTable" size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%">
      <el-table-column align="center" prop="id" label="线路编号" min-width="150"></el-table-column>
      <el-table-column align="center" prop="map_name_cn" label="所属地图" min-width="240"></el-table-column>
      <el-table-column align="center" prop="line_name_cn" label="线路名称" min-width="240"></el-table-column>
      <el-table-column align="center" prop="create_time" label="加入时间" min-width="240">
      </el-table-column>
      <el-table-column align="center" prop="remark" label="备注" min-width="500"></el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="250"
        v-if="check_auth('/web/area/area_line_detail') || check_auth('/web/area/area_line_edit') || check_auth('/web/area/area_unbind_line')">
        <template slot-scope="scope">
          <el-button size="mini" round @click="createMap(scope.row)"
            v-if="check_auth('/web/area/area_line_detail')">详情</el-button>
          <el-button size="mini" type="primary" @click="getOneLine(scope.row)" round
            v-if="check_auth('/web/area/area_line_edit')">编辑</el-button>
          <el-button size="mini" type="danger" @click="delLine(scope.row)" round
            v-if="check_auth('/web/area/area_unbind_line')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 添加线路 -->
    <el-dialog title="添加" :visible.sync="dialogTableVisible" width="35%" @click="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <el-form :model="form" label-width="13%" :rules="rules" ref="form">
        <el-form-item label="选择地图" prop="map_id">
          <el-select v-model="form.map_id" filterable clearable placeholder="请选择" size="small" @change="selectMap"
            style="width:100%">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择线路" prop="line_id">
          <el-select v-model="form.line_id" multiple :disabled="disabled" clearable placeholder="请选择" size="small"
            style="width:100%" @change="getLine">
            <el-option v-for="item in moreoptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="importLine('form')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog title="编辑" :visible.sync="editFormVisible" width="35%" @click="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <el-form label-width="13%" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="线路编号" prop="id">
          <el-input size="small" v-model="editForm.id" auto-complete="off" disabled placeholder="请输入线路编号"></el-input>
        </el-form-item>
        <el-form-item label="线路名称" prop="name_cn">
          <el-input size="small" v-model="editForm.name_cn" auto-complete="off" disabled placeholder="请输入线路名称">
          </el-input>
        </el-form-item>
        <el-form-item label="所属地图" prop="map_name_cn">
          <el-input size="small" v-model="editForm.map_name_cn" auto-complete="off" disabled placeholder="请输入所属地图">
          </el-input>
        </el-form-item>
        <el-form-item label="加入时间" prop="create_time">
          <el-date-picker v-model="editForm.create_time" disabled style="width: 100%" type="datetime" clearable
            default-time="12:00:00" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="type">
          <el-input type="textarea" rows="3" size="small" v-model="editForm.remark" auto-complete="off"
            placeholder="请输入备注">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
    <!-- 地图 -->
    <el-dialog title="地图" :visible.sync="createMapshow" width="40%" @click="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <div id="containertwo"></div>
    </el-dialog>
  </div>
</template>

<script>
let conmap = "";
import {
  get_region_list,
  get_area_map,
  get_area_map_line,
  area_bind_line,
  get_area_line_one,
  get_area_line_edit,
  get_area_line_detail,
  get_del_area_line,
} from "../../api/region/area_line";
import {
  auth
} from "../../utils/util";
import Pagination from "../../components/Pagination";
import AMap from "AMap";
export default {
  line_name: "areaLine",
  data() {
    return {
      editFormVisible: false,
      activeline_name: "first",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      dialogTableVisible: false,
      dialogVisible: false,
      createMapshow: false,
      options: [],
      moreoptions: [],
      ids: [],
      linePath: [],
      disabled: true,
      editForm: {
        id: "",
        name_cn: "",
        map_name_cn: "",
        create_time: "",
        remark: "",
      },
      form: {
        map_id: "",
        line_id: [],
      },

      // rules表单验证
      rules: {
        line_name_cn: [
          { required: true, message: "请输入线路名称", trigger: "blur" },
        ],
        map_name_cn: [
          { required: true, message: "请输入所属地图", trigger: "blur" },
        ],
        id: [{ required: true, message: "请输入线路编号", trigger: "blur" }],
        create_time: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        map_name_cn: "",
        line_name_cn: "",
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },

  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 创建完毕
   */
  // created() {
  //   this.getdata();
  // },
  mounted() {
    this.$nextTick(function () {
      this.$on("childmethod", function () {
        this.getLineData();
        this.disabled = true;
      });
    });
    // this.getLineData();
  },
  methods: {
    childmethod() { },
    async getCreateMap(row) {
      return get_area_line_detail(row.id).then((res) => {
        if (res["code"] === 0) {
          this.linePath = res.data;
        }
      });
    },
    check_auth(val) {
      return auth(val);
    },
    // 地图
    async createMap(row) {
      this.createMapshow = true;
      await this.getCreateMap(row);
      //创建地图
      setTimeout(() => {
        conmap = new AMap.Map("containertwo", {
          resizeEnable: true, //是否监控地图容器尺寸变化
          zoom: 25, //初始化地图层级
          center: [118.054994, 36.813787], //初始化地图中心点
        });

        this.guiji();
      }, 100);
    },
    guiji() {
      let a = [];
      let lnglat = [];
      let _path = [];
      a = this.linePath;

      for (let i = 0; i < a.length; i++) {
        lnglat.push(new AMap.LngLat(parseFloat(a[i]["lon"]), parseFloat(a[i]["lat"])));
      }
      AMap.convertFrom(lnglat, 'gps', function (status, result) {
        if (result.info === 'ok') {
          var resLnglat = result.locations;
          for (let i = 0; i < resLnglat.length; i++) {
            _path.push([resLnglat[i].lng, resLnglat[i].lat]);
          }
          AMapUI.load(
            ["ui/misc/PathSimplifier", "lib/$"],
            function (PathSimplifier, $) {
              if (!PathSimplifier.supportCanvas) {
                alert("当前环境不支持 Canvas！");
                return;
              }

              var pathSimplifierIns = new PathSimplifier({
                zIndex: 10,
                //autoSetFitView:false,
                map: conmap, //所属的地图实例

                getPath: function (pathData, pathIndex) {
                  return pathData.path;
                },
                getHoverTitle: function (pathData, pathIndex, pointIndex) {
                  if (pointIndex >= 0) {
                    //point
                    return (
                      pathData.line_name +
                      "，点：" +
                      pointIndex +
                      "/" +
                      pathData.path.length
                    );
                  }

                  return pathData.line_name + "，点数量" + pathData.path.length;
                },
                renderOptions: {
                  renderAllPointsIfNumberBelow: 100, //绘制路线节点，如不需要可设置为-1
                },
              });
              window.pathSimplifierIns = pathSimplifierIns;

              //设置数据

              pathSimplifierIns.setData([
                {
                  line_name: "路线0",
                  path: _path,
                },
              ]);

              //对第一条线路（即索引 0）创建一个巡航器
              var navg1 = pathSimplifierIns.createPathNavigator(0, {
                loop: true, //循环播放
                speed: 100, //巡航速度，单位千米/小时
              });

              navg1.start();
            }
          );
        }
      });

    },
    // 获取公司列表
    getLineData() {
      get_region_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data.data;
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data["total"];
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getLineData();
    },
    // 搜索事件
    search() {
      this.getLineData();
    },
    // 添加线路
    addLine() {
      this.dialogTableVisible = true;
      this.form = {};
      this.ids = [];
      this.disabled = true;
      this.getMap();
    },
    // 地图列表
    getMap() {
      get_area_map().then((res) => {
        if (res["code"] == 0) {
          this.options = res.data;
        }
      });
    },
    // 选择地图
    selectMap() {
      if (this.form.map_id != "") {
        this.disabled = false;
        this.form.line_id = [];
        this.getLine();
      } else {
        this.disabled = true;
        this.form.line_id = [];
      }
    },
    // 线路列表
    getLine() {
      get_area_map_line(this.form).then((res) => {
        if (res["code"] == 0) {
          this.moreoptions = res.data;
        }
      });
    },
    // 添加线路的保存
    importLine(addData) {
      this.$refs[addData].validate((valid) => {
        if (valid) {
          for (var i = 0; i < this.form.line_id.length; i++) {
            this.ids.push(this.form.line_id[i]);
          }
          var strs = this.ids.join(",");
          if (this.form.map_id == undefined) {
            this.$message.error("请选择地图")
          } else {
            area_bind_line(this.form, strs).then((res) => {
              if (res["code"] === 0) {
                this.dialogTableVisible = false;
                this.getLineData();
                this.$message.success(res["message"]);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 获取单条
    getOneLine(row) {
      this.editFormVisible = true;
      get_area_line_one(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
        }
      });
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          get_area_line_edit(this.editForm).then((res) => {
            this.editFormVisible = false;
            if (res["code"] === 0) {
              this.getLineData();
              this.$message.success(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    delLine(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          get_del_area_line(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getLineData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getLineData();
                }
              } else {
                this.getLineData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.dialogTableVisible = false;
      this.editFormVisible = false;
      this.createMapshow = false;
      conmap.destroy();
    },
  },
};
</script>
<style scoped>
#containertwo {
  width: 100%;
  height: 600px;
}

.head {
  width: 99%;
  padding-bottom: 1%;
  margin-top: 1%;
  margin-left: 1%;
  font-size: 20px;
  color: #334157;
  border-bottom: 1px solid #f5f5f5;
}

el-tabs {
  margin-left: 1%;
}

.userRole {
  width: 100%;
}

.elTable /deep/ td {
  padding: 0.5% 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/region_mn/line.vue